import React from 'react';

const style = () => (
  <style type="text/css">
    {`
      #hs-eu-cookie-confirmation {
        width: 370px !important;
        bottom: 20px !important;
        right: 0px !important;
        left: 20px !important;
        top: auto !important;
        position: fixed !important;
        border: none !important;
        border-radius: 10px;
        overflow: "hidden";
        height: auto !important;
        font-family: "Graphik", sans-serif !important;
        box-shadow: rgba(34, 45, 57, 0.12) 0px 0px 0px 1px, rgba(34, 45, 57, 0.12) 0px 1px 2px 0px !important;
      }

      #hs-eu-cookie-confirmation-inner {
        background: transparent !important;
        padding: 15px 20px !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
      }

      div#hs-eu-cookie-confirmation div#hs-eu-cookie-confirmation-inner div#hs-en-cookie-confirmation-buttons-area a#hs-eu-confirmation-button,
      div#hs-eu-cookie-confirmation div#hs-eu-cookie-confirmation-inner div#hs-en-cookie-confirmation-buttons-area a#hs-eu-decline-button {
        padding: 0px 16px!important;
        border: none !important;
        height: 36px !important;
        padding: 0px 16px!important;
        font-weight: 500 !important;
        line-height: 36px !important;
        margin-right: 0px !important;
        border-radius: 18px !important;
      }

      div#hs-eu-cookie-confirmation div#hs-eu-cookie-confirmation-inner a#hs-eu-confirmation-button {
        background-color: #1fb6ff !important;
        margin-top: -15px !important;
      }

      div#hs-eu-cookie-confirmation div#hs-eu-cookie-confirmation-inner a#hs-eu-confirmation-button:hover {  }

      div#hs-eu-cookie-confirmation-inner #hs-eu-policy-wording {
        margin-bottom: 0px !important;
      }

      div#hs-eu-cookie-confirmation-inner p {
        font-size: 13px !important;
        line-height: 22px !important;
        font-family: "Graphik", sans-serif !important;
        padding-right: 10px !important;
        letter-spacing: 0px !important;
        color: #222d39 !important;
        margin-bottom: 0px !important;
      }
    `}
  </style>
);

export default style;



// WEBPACK FOOTER //
// ./src/components/modules/CookieStyles/index.js